__turbopack_context__.v({
  "about": "_7glVja_about",
  "accordions": "_7glVja_accordions",
  "coaches": "_7glVja_coaches",
  "columns": "_7glVja_columns",
  "contact": "_7glVja_contact",
  "info": "_7glVja_info",
  "mark": "_7glVja_mark",
  "packageContent": "_7glVja_packageContent",
  "packagePhoto": "_7glVja_packagePhoto",
  "packages": "_7glVja_packages",
  "photoBand": "_7glVja_photoBand",
  "portrait": "_7glVja_portrait",
  "portraits": "_7glVja_portraits",
  "price": "_7glVja_price",
  "stepLabel": "_7glVja_stepLabel",
  "steps": "_7glVja_steps",
});
